import { RouteLoadingShell } from "@/components/portal/route-loading-shell";

export default function AdminLegacyModelsLoading() {
  return <RouteLoadingShell variant="admin-table" />;
}
